import { useRecoilValue, useSetRecoilState } from "recoil";
import { loginState } from "../../stores/loginState";
import { useMutation } from "react-query";
import { HandexInstance, HanjinInstance, LogenInstance, LotteInstance } from "../instance";
import dayjs from "dayjs";
import { barcodeDataState } from "../../stores/barcode/barcodeDataState";
import Swal from "sweetalert2";

// TODO 운송장 조회 API
const useGetBarcodeData = ({ startDate, endDate, workType, barcode}) => {
  // NOTE 상태 변수 선언
  const login = useRecoilValue(loginState); // 로그인
  const setBarcodeData = useSetRecoilState(barcodeDataState); // 운송장 조회 데이터 전역변수

  // NOTE 데이터 정제
  const filterData = (data) => {
    return data.filter(item => {
      const itemDate = dayjs(item.scandate).format("YYYY-MM-DD");
      const matchesDate = itemDate >= startDate && itemDate <= endDate;
      const matchesWorkType = workType === "전체" || item.tm_dv === workType;
      const matchesBarcode = !barcode || item.barcode.includes(barcode);

      return matchesDate && matchesWorkType && matchesBarcode;
    });
  };

  // TODO API 결과
  const mutationOptions = {
    // 성공 시
    onSuccess: (data) => {
      if (data.result === "00" || data.result === "77") {
        const filteredData = filterData(data.data);
        setBarcodeData(filteredData);
        Swal.fire({
          icon: "success",
          title: "데이터를 성공적으로 조회하였습니다!",
          confirmButtonText: "확인",
        });
      }
    },
    // 실패 시
    onError: (error) => {
      Swal.fire({
        icon: "warning",
        title: "데이터를 조회하는데 문제가 발생하였습니다!",
        confirmButtonText: "확인",
      });
      console.log(error);
    },
  };

  // TODO API 리퀘스트 정보
  const postData = {
    api: "dvInAll",
    data: [
      {
        start_time: `${dayjs(startDate).format("YYYY-MM-DD")} 00:00:00`,
        end_time: `${dayjs(endDate).format("YYYY-MM-DD")} 23:59:59`,
        bran_cd: login.branchCode,
        longTime: "",
        car_num: "",
        company: login.company
      },
    ],
  };

  let mutationFn;

  // TODO API 회사별
  if (login.company === "LOGEN") {
    mutationFn = () => LogenInstance.post("/lose", postData);
  } else if (login.company === "LOTTE") {
    mutationFn = () => LotteInstance.post("/lose", postData);
  } else if (login.company === "HANJIN") {
    mutationFn = () => HanjinInstance.post("/lose", postData);
  } else if (login.company === "HANDEX") {
    mutationFn = () => HandexInstance.post("/lose", postData);
  } else {
    mutationFn = () => {
      Swal.fire({
        icon: "warning",
        title: "고객사가 잘못되었습니다!",
        confirmButtonText: "확인",
      });
    };
  }

  return useMutation("getAmount", mutationFn, mutationOptions);
};

export default useGetBarcodeData;
